import { appLaunch } from 'modules/authentication/actions'
import { store } from '../config/redux'
import { setJWT, setAppDetails, setIsApp } from '../modules/appSettings/actions'

export const startBridge = () => {
    window.updateData = data => {
        const parsedResponse = JSON.parse(data.replace(/\s/g, ''))
        if (window.location.search.includes('app=true')) {
            store.dispatch(setIsApp(true))
        }
        const { accessToken, refreshToken } = parsedResponse
        store.dispatch(
            setJWT({
                access_token: accessToken,
                refresh_token: refreshToken,
            })
        )
        store.dispatch(setIsApp(true))
        store.dispatch(setAppDetails(parsedResponse))
        store.dispatch(appLaunch(accessToken, refreshToken))
    }
}
/**
 * This will add the script tag so it wont block the page.
 */
export const startStripe = () => {
    const b = document.createElement('script')
    b.type = 'text/javascript'
    b.async = !0
    b.src = 'https://js.stripe.com/v3/'
    const c = document.getElementsByTagName('script')[4]
    c.parentNode.insertBefore(b, c)
}
